export interface DialCode {
    iso2: string
    name: string
    code: string
}

// United Kingdom first as the default, then alphabetical
export const dialCodes: DialCode[] = [
    { iso2: 'GB', name: 'United Kingdom', code: '44' },
    { iso2: 'AF', name: 'Afghanistan', code: '93' },
    { iso2: 'AX', name: 'Åland Islands', code: '358' },
    { iso2: 'AL', name: 'Albania', code: '355' },
    { iso2: 'DZ', name: 'Algeria', code: '213' },
    { iso2: 'AS', name: 'American Samoa', code: '1' },
    { iso2: 'AD', name: 'Andorra', code: '376' },
    { iso2: 'AO', name: 'Angola', code: '244' },
    { iso2: 'AI', name: 'Anguilla', code: '1' },
    { iso2: 'AQ', name: 'Antarctica', code: '672' },
    { iso2: 'AG', name: 'Antigua and Barbuda', code: '1' },
    { iso2: 'AR', name: 'Argentina', code: '54' },
    { iso2: 'AM', name: 'Armenia', code: '374' },
    { iso2: 'AW', name: 'Aruba', code: '297' },
    { iso2: 'AU', name: 'Australia', code: '61' },
    { iso2: 'AT', name: 'Austria', code: '43' },
    { iso2: 'AZ', name: 'Azerbaijan', code: '994' },
    { iso2: 'BS', name: 'Bahamas', code: '1' },
    { iso2: 'BH', name: 'Bahrain', code: '973' },
    { iso2: 'BD', name: 'Bangladesh', code: '880' },
    { iso2: 'BB', name: 'Barbados', code: '1' },
    { iso2: 'BY', name: 'Belarus', code: '375' },
    { iso2: 'BE', name: 'Belgium', code: '32' },
    { iso2: 'BZ', name: 'Belize', code: '501' },
    { iso2: 'BJ', name: 'Benin', code: '229' },
    { iso2: 'BM', name: 'Bermuda', code: '1' },
    { iso2: 'BT', name: 'Bhutan', code: '975' },
    { iso2: 'BO', name: 'Bolivia', code: '591' },
    { iso2: 'BA', name: 'Bosnia and Herzegovina', code: '387' },
    { iso2: 'BW', name: 'Botswana', code: '267' },
    { iso2: 'BV', name: 'Bouvet Island', code: '47' },
    { iso2: 'BR', name: 'Brazil', code: '55' },
    { iso2: 'IO', name: 'British Indian Ocean Territory', code: '246' },
    { iso2: 'VG', name: 'British Virgin Islands', code: '1' },
    { iso2: 'BN', name: 'Brunei', code: '673' },
    { iso2: 'BG', name: 'Bulgaria', code: '359' },
    { iso2: 'BF', name: 'Burkina Faso', code: '226' },
    { iso2: 'BI', name: 'Burundi', code: '257' },
    { iso2: 'KH', name: 'Cambodia', code: '855' },
    { iso2: 'CM', name: 'Cameroon', code: '237' },
    { iso2: 'CA', name: 'Canada', code: '1' },
    { iso2: 'CV', name: 'Cape Verde', code: '238' },
    { iso2: 'BQ', name: 'Caribbean Netherlands', code: '599' },
    { iso2: 'KY', name: 'Cayman Islands', code: '1' },
    { iso2: 'CF', name: 'Central African Republic', code: '236' },
    { iso2: 'TD', name: 'Chad', code: '235' },
    { iso2: 'CL', name: 'Chile', code: '56' },
    { iso2: 'CN', name: 'China', code: '86' },
    { iso2: 'CX', name: 'Christmas Island', code: '61' },
    { iso2: 'CC', name: 'Cocos (Keeling) Islands', code: '61' },
    { iso2: 'CO', name: 'Colombia', code: '57' },
    { iso2: 'KM', name: 'Comoros', code: '269' },
    { iso2: 'CG', name: 'Congo', code: '242' },
    { iso2: 'CD', name: 'Congo (DRC)', code: '243' },
    { iso2: 'CK', name: 'Cook Islands', code: '682' },
    { iso2: 'CR', name: 'Costa Rica', code: '506' },
    { iso2: 'CI', name: "Côte d'Ivoire", code: '225' },
    { iso2: 'HR', name: 'Croatia', code: '385' },
    { iso2: 'CU', name: 'Cuba', code: '53' },
    { iso2: 'CW', name: 'Curaçao', code: '599' },
    { iso2: 'CY', name: 'Cyprus', code: '357' },
    { iso2: 'CZ', name: 'Czechia', code: '420' },
    { iso2: 'DK', name: 'Denmark', code: '45' },
    { iso2: 'DJ', name: 'Djibouti', code: '253' },
    { iso2: 'DM', name: 'Dominica', code: '1' },
    { iso2: 'DO', name: 'Dominican Republic', code: '1' },
    { iso2: 'EC', name: 'Ecuador', code: '593' },
    { iso2: 'EG', name: 'Egypt', code: '20' },
    { iso2: 'SV', name: 'El Salvador', code: '503' },
    { iso2: 'GQ', name: 'Equatorial Guinea', code: '240' },
    { iso2: 'ER', name: 'Eritrea', code: '291' },
    { iso2: 'EE', name: 'Estonia', code: '372' },
    { iso2: 'SZ', name: 'Eswatini', code: '268' },
    { iso2: 'ET', name: 'Ethiopia', code: '251' },
    { iso2: 'FK', name: 'Falkland Islands', code: '500' },
    { iso2: 'FO', name: 'Faroe Islands', code: '298' },
    { iso2: 'FJ', name: 'Fiji', code: '679' },
    { iso2: 'FI', name: 'Finland', code: '358' },
    { iso2: 'FR', name: 'France', code: '33' },
    { iso2: 'GF', name: 'French Guiana', code: '594' },
    { iso2: 'PF', name: 'French Polynesia', code: '689' },
    { iso2: 'TF', name: 'French Southern Territories', code: '262' },
    { iso2: 'GA', name: 'Gabon', code: '241' },
    { iso2: 'GM', name: 'Gambia', code: '220' },
    { iso2: 'GE', name: 'Georgia', code: '995' },
    { iso2: 'DE', name: 'Germany', code: '49' },
    { iso2: 'GH', name: 'Ghana', code: '233' },
    { iso2: 'GI', name: 'Gibraltar', code: '350' },
    { iso2: 'GR', name: 'Greece', code: '30' },
    { iso2: 'GL', name: 'Greenland', code: '299' },
    { iso2: 'GD', name: 'Grenada', code: '1' },
    { iso2: 'GP', name: 'Guadeloupe', code: '590' },
    { iso2: 'GU', name: 'Guam', code: '1' },
    { iso2: 'GT', name: 'Guatemala', code: '502' },
    { iso2: 'GG', name: 'Guernsey', code: '44' },
    { iso2: 'GN', name: 'Guinea', code: '224' },
    { iso2: 'GW', name: 'Guinea-Bissau', code: '245' },
    { iso2: 'GY', name: 'Guyana', code: '592' },
    { iso2: 'HT', name: 'Haiti', code: '509' },
    { iso2: 'HM', name: 'Heard Island and McDonald Islands', code: '672' },
    { iso2: 'HN', name: 'Honduras', code: '504' },
    { iso2: 'HK', name: 'Hong Kong', code: '852' },
    { iso2: 'HU', name: 'Hungary', code: '36' },
    { iso2: 'IS', name: 'Iceland', code: '354' },
    { iso2: 'IN', name: 'India', code: '91' },
    { iso2: 'ID', name: 'Indonesia', code: '62' },
    { iso2: 'IR', name: 'Iran', code: '98' },
    { iso2: 'IQ', name: 'Iraq', code: '964' },
    { iso2: 'IE', name: 'Ireland', code: '353' },
    { iso2: 'IM', name: 'Isle of Man', code: '44' },
    { iso2: 'IL', name: 'Israel', code: '972' },
    { iso2: 'IT', name: 'Italy', code: '39' },
    { iso2: 'JM', name: 'Jamaica', code: '1' },
    { iso2: 'JP', name: 'Japan', code: '81' },
    { iso2: 'JE', name: 'Jersey', code: '44' },
    { iso2: 'JO', name: 'Jordan', code: '962' },
    { iso2: 'KZ', name: 'Kazakhstan', code: '7' },
    { iso2: 'KE', name: 'Kenya', code: '254' },
    { iso2: 'KI', name: 'Kiribati', code: '686' },
    { iso2: 'XK', name: 'Kosovo', code: '383' },
    { iso2: 'KW', name: 'Kuwait', code: '965' },
    { iso2: 'KG', name: 'Kyrgyzstan', code: '996' },
    { iso2: 'LA', name: 'Laos', code: '856' },
    { iso2: 'LV', name: 'Latvia', code: '371' },
    { iso2: 'LB', name: 'Lebanon', code: '961' },
    { iso2: 'LS', name: 'Lesotho', code: '266' },
    { iso2: 'LR', name: 'Liberia', code: '231' },
    { iso2: 'LY', name: 'Libya', code: '218' },
    { iso2: 'LI', name: 'Liechtenstein', code: '423' },
    { iso2: 'LT', name: 'Lithuania', code: '370' },
    { iso2: 'LU', name: 'Luxembourg', code: '352' },
    { iso2: 'MO', name: 'Macau', code: '853' },
    { iso2: 'MG', name: 'Madagascar', code: '261' },
    { iso2: 'MW', name: 'Malawi', code: '265' },
    { iso2: 'MY', name: 'Malaysia', code: '60' },
    { iso2: 'MV', name: 'Maldives', code: '960' },
    { iso2: 'ML', name: 'Mali', code: '223' },
    { iso2: 'MT', name: 'Malta', code: '356' },
    { iso2: 'MH', name: 'Marshall Islands', code: '692' },
    { iso2: 'MQ', name: 'Martinique', code: '596' },
    { iso2: 'MR', name: 'Mauritania', code: '222' },
    { iso2: 'MU', name: 'Mauritius', code: '230' },
    { iso2: 'YT', name: 'Mayotte', code: '262' },
    { iso2: 'MX', name: 'Mexico', code: '52' },
    { iso2: 'FM', name: 'Micronesia', code: '691' },
    { iso2: 'MD', name: 'Moldova', code: '373' },
    { iso2: 'MC', name: 'Monaco', code: '377' },
    { iso2: 'MN', name: 'Mongolia', code: '976' },
    { iso2: 'ME', name: 'Montenegro', code: '382' },
    { iso2: 'MS', name: 'Montserrat', code: '1' },
    { iso2: 'MA', name: 'Morocco', code: '212' },
    { iso2: 'MZ', name: 'Mozambique', code: '258' },
    { iso2: 'MM', name: 'Myanmar', code: '95' },
    { iso2: 'NA', name: 'Namibia', code: '264' },
    { iso2: 'NR', name: 'Nauru', code: '674' },
    { iso2: 'NP', name: 'Nepal', code: '977' },
    { iso2: 'NL', name: 'Netherlands', code: '31' },
    { iso2: 'NC', name: 'New Caledonia', code: '687' },
    { iso2: 'NZ', name: 'New Zealand', code: '64' },
    { iso2: 'NI', name: 'Nicaragua', code: '505' },
    { iso2: 'NE', name: 'Niger', code: '227' },
    { iso2: 'NG', name: 'Nigeria', code: '234' },
    { iso2: 'NU', name: 'Niue', code: '683' },
    { iso2: 'NF', name: 'Norfolk Island', code: '672' },
    { iso2: 'KP', name: 'North Korea', code: '850' },
    { iso2: 'MK', name: 'North Macedonia', code: '389' },
    { iso2: 'MP', name: 'Northern Mariana Islands', code: '1' },
    { iso2: 'NO', name: 'Norway', code: '47' },
    { iso2: 'OM', name: 'Oman', code: '968' },
    { iso2: 'PK', name: 'Pakistan', code: '92' },
    { iso2: 'PW', name: 'Palau', code: '680' },
    { iso2: 'PS', name: 'Palestine', code: '970' },
    { iso2: 'PA', name: 'Panama', code: '507' },
    { iso2: 'PG', name: 'Papua New Guinea', code: '675' },
    { iso2: 'PY', name: 'Paraguay', code: '595' },
    { iso2: 'PE', name: 'Peru', code: '51' },
    { iso2: 'PH', name: 'Philippines', code: '63' },
    { iso2: 'PN', name: 'Pitcairn Islands', code: '64' },
    { iso2: 'PL', name: 'Poland', code: '48' },
    { iso2: 'PT', name: 'Portugal', code: '351' },
    { iso2: 'PR', name: 'Puerto Rico', code: '1' },
    { iso2: 'QA', name: 'Qatar', code: '974' },
    { iso2: 'RE', name: 'Réunion', code: '262' },
    { iso2: 'RO', name: 'Romania', code: '40' },
    { iso2: 'RU', name: 'Russia', code: '7' },
    { iso2: 'RW', name: 'Rwanda', code: '250' },
    { iso2: 'BL', name: 'Saint Barthélemy', code: '590' },
    { iso2: 'SH', name: 'Saint Helena', code: '290' },
    { iso2: 'KN', name: 'Saint Kitts and Nevis', code: '1' },
    { iso2: 'LC', name: 'Saint Lucia', code: '1' },
    { iso2: 'MF', name: 'Saint Martin', code: '590' },
    { iso2: 'PM', name: 'Saint Pierre and Miquelon', code: '508' },
    { iso2: 'VC', name: 'Saint Vincent and the Grenadines', code: '1' },
    { iso2: 'WS', name: 'Samoa', code: '685' },
    { iso2: 'SM', name: 'San Marino', code: '378' },
    { iso2: 'ST', name: 'São Tomé and Príncipe', code: '239' },
    { iso2: 'SA', name: 'Saudi Arabia', code: '966' },
    { iso2: 'SN', name: 'Senegal', code: '221' },
    { iso2: 'RS', name: 'Serbia', code: '381' },
    { iso2: 'SC', name: 'Seychelles', code: '248' },
    { iso2: 'SL', name: 'Sierra Leone', code: '232' },
    { iso2: 'SG', name: 'Singapore', code: '65' },
    { iso2: 'SX', name: 'Sint Maarten', code: '1' },
    { iso2: 'SK', name: 'Slovakia', code: '421' },
    { iso2: 'SI', name: 'Slovenia', code: '386' },
    { iso2: 'SB', name: 'Solomon Islands', code: '677' },
    { iso2: 'SO', name: 'Somalia', code: '252' },
    { iso2: 'ZA', name: 'South Africa', code: '27' },
    { iso2: 'GS', name: 'South Georgia and the South Sandwich Islands', code: '500' },
    { iso2: 'KR', name: 'South Korea', code: '82' },
    { iso2: 'SS', name: 'South Sudan', code: '211' },
    { iso2: 'ES', name: 'Spain', code: '34' },
    { iso2: 'LK', name: 'Sri Lanka', code: '94' },
    { iso2: 'SD', name: 'Sudan', code: '249' },
    { iso2: 'SR', name: 'Suriname', code: '597' },
    { iso2: 'SJ', name: 'Svalbard and Jan Mayen', code: '47' },
    { iso2: 'SE', name: 'Sweden', code: '46' },
    { iso2: 'CH', name: 'Switzerland', code: '41' },
    { iso2: 'SY', name: 'Syria', code: '963' },
    { iso2: 'TW', name: 'Taiwan', code: '886' },
    { iso2: 'TJ', name: 'Tajikistan', code: '992' },
    { iso2: 'TZ', name: 'Tanzania', code: '255' },
    { iso2: 'TH', name: 'Thailand', code: '66' },
    { iso2: 'TL', name: 'Timor-Leste', code: '670' },
    { iso2: 'TG', name: 'Togo', code: '228' },
    { iso2: 'TK', name: 'Tokelau', code: '690' },
    { iso2: 'TO', name: 'Tonga', code: '676' },
    { iso2: 'TT', name: 'Trinidad and Tobago', code: '1' },
    { iso2: 'TN', name: 'Tunisia', code: '216' },
    { iso2: 'TR', name: 'Turkey', code: '90' },
    { iso2: 'TM', name: 'Turkmenistan', code: '993' },
    { iso2: 'TC', name: 'Turks and Caicos Islands', code: '1' },
    { iso2: 'TV', name: 'Tuvalu', code: '688' },
    { iso2: 'UM', name: 'U.S. Outlying Islands', code: '1' },
    { iso2: 'VI', name: 'U.S. Virgin Islands', code: '1' },
    { iso2: 'UG', name: 'Uganda', code: '256' },
    { iso2: 'UA', name: 'Ukraine', code: '380' },
    { iso2: 'AE', name: 'United Arab Emirates', code: '971' },
    { iso2: 'US', name: 'United States', code: '1' },
    { iso2: 'UY', name: 'Uruguay', code: '598' },
    { iso2: 'UZ', name: 'Uzbekistan', code: '998' },
    { iso2: 'VU', name: 'Vanuatu', code: '678' },
    { iso2: 'VA', name: 'Vatican City', code: '39' },
    { iso2: 'VE', name: 'Venezuela', code: '58' },
    { iso2: 'VN', name: 'Vietnam', code: '84' },
    { iso2: 'WF', name: 'Wallis and Futuna', code: '681' },
    { iso2: 'EH', name: 'Western Sahara', code: '212' },
    { iso2: 'YE', name: 'Yemen', code: '967' },
    { iso2: 'ZM', name: 'Zambia', code: '260' },
    { iso2: 'ZW', name: 'Zimbabwe', code: '263' },
]

// Main country for dial codes shared by several countries, used when splitting a saved "+1 ..." number
export const mainCountryForCode: Record<string, string> = {
    '1': 'US',
    '7': 'RU',
    '39': 'IT',
    '44': 'GB',
    '47': 'NO',
    '61': 'AU',
    '212': 'MA',
    '262': 'RE',
    '358': 'FI',
    '590': 'GP',
    '599': 'CW',
    '672': 'NF',
}

// Countries whose national numbers keep their leading 0 after the dial code
const keepsLeadingZero = ['IT', 'SM', 'VA']

export const toInternationalNumber = (iso2: string, nationalNumber: string) => {
    const trimmed = nationalNumber.trim()
    if (trimmed.startsWith('+')) return trimmed
    const dialCode = dialCodes.find((d) => d.iso2 === iso2)
    if (!dialCode) return trimmed
    const national = keepsLeadingZero.includes(iso2) ? trimmed : trimmed.replace(/^0/, '')
    return `+${dialCode.code} ${national}`
}
